// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"8ab80696","46":"8ab80696","363":"8ab80696","533":"8ab80696","677":"8ab80696"}[chunkId] + ".chunk.css";
};